import OkC from "shared/util/OkcApi";

/*
 * Upload a photo's crop information to the server
 *
 * @param {object} params - An object with the required keys:
 *  - userid
 *	- id
 *	- width
 *	- height
 *	- topLeftX
 *	- topLeftY
 *	- bottomRightX
 *	- bottomRightY
 * @return {promise}
 */
export default function uploadPhotoDetails(params) {
	if (!params.userid) {
		return Promise.reject({
			error: "uploadPhotoDetails: no userid",
		});
	}

	if (!params.picid || !params.width || !params.height) {
		return Promise.reject({
			error: `uploadPhotoDetails: missing photo info, ${JSON.stringify(params)}`,
		});
	}

	if (typeof (params.cropInfo) === "undefined" || params.cropInfo === null) {
		return Promise.reject({
			error: "uploadPhotoDetails: missing crop info",
		});
	}

	const data = {
		userid: params.userid,
		picid: params.picid,
		albumid: params.albumid,
		width: params.width,
		height: params.height,
		tn_upper_left_x: Math.floor(params.cropInfo.topLeftX),
		tn_upper_left_y: Math.floor(params.cropInfo.topLeftY),
		tn_lower_right_x: Math.floor(params.cropInfo.bottomRightX),
		tn_lower_right_y: Math.floor(params.cropInfo.bottomRightY),

		// magic incantations
		user_new_upload: 1,
		okc_api: 1,
		ok_api: 1,
	};

	if (params.albumid) {
		data.status = 10;
		data["picture.add_pic_album_ajax"] = 1;
	} else {
		data["picture.add_ajax"] = 1;
	}

	return OkC.legacy("/photoupload", {
		data,
	});
}



// WEBPACK FOOTER //
// ./src/shared/util/PhotoUpload/uploadPhotoDetails.js